import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { TokenService } from './token.service';
import { environment } from './../environments/environment';
import { ToastService } from '@app/services/toast.service';
import { EncryptionService } from '../app/services/encryption.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  environments = environment;

  constructor(
    private tokenService: TokenService,
    private authService: AuthService,
    private toastr: ToastService,
    private encryptionService: EncryptionService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip interception for specific endpoints
    if (request.url.includes('cif-form-status') || request.url.includes('cif-form-by-token') || request.url.includes('customer-cif') || request.url.includes('form/otp')) {
      request = request.clone({
        setHeaders: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      });
      console.log('Skipping CIF Form Status request interception');
      return next.handle(request);
    }

    // console.log('Auth Interceptor triggered');
    const token = this.tokenService.getsessionToken('token');
    const loginType = this.encryptionService.getFromLocalStorage('user_type');
    const isGdcOrderListApi = request.url.includes('/api/orders/gdc/get/order-list/');
    // const appName = isGdcOrderListApi ? environment.GDC_APP_NAME : environment.TML_APP_NAME;
    const appName = loginType?.toLocaleLowerCase() === 'dealer' 
    ? environment.CRM_APP_NAME 
    : loginType?.toLocaleLowerCase() === 'gdc' 
    ? environment.GDC_APP_NAME 
    : loginType?.toLocaleLowerCase() === 'customer' 
    ? environment.TML_APP_NAME 
    : loginType?.toLocaleLowerCase() === 'call_centre' 
    ? environment.CALLCENTER_APP_NAME
    : loginType?.toLocaleLowerCase() === 'approver' 
    ? environment.APPROVER_APP_NAME 
    : environment.CRM_APP_NAME; // Optional default value
    // Prepare headers
    const headers: { [key: string]: string } = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    };

    if (!request.url.includes('/auth/login/') && !request.url.includes('/auth/fv/identity/process/')) {
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      if (['POST', 'PUT', 'PATCH'].includes(request.method)) {
        request = request.clone({
          body: {
            ...request.body,
            app_name: appName
          }
        });
      }
    }
 
    request = request.clone({ setHeaders: headers });

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // console.log('Successful response intercepted');
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        this.toastr.clear();
        console.error('HTTP-ERRORS From Auth:', error);

        // Show error message if available
        const errorMsg = error?.error?.error || error?.error?.msg || 'An unknown error occurred.';
        // this.toastr.error(errorMsg);

        if (error.status === 401 || error.status === 403) {
          console.log('Invalid or expired token');
          this.authService.checkValidateToken();
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('access_token');
        } else if (error.status === 400) {
          console.log('Bad request (400)');
          this.toastr.error("Bad Request");
        } 
        else if (error.status === 423) {
          console.log('Bad request (423)',error);
          this.toastr.error('You are unauthorized');
          this.authService.logout();
        } 
        else if (error.status === 406) {
          console.log('Bad request (406)',error);
          this.toastr.error("You Don't have permission to access");
        } 
        return throwError(() => error);
      })
    );
  }
}
